module.exports = __webpack_public_path__ + "static/media/logo-footer.5475559a.png";